import axiosInstance from "../axiosInstance";

export const getServices = async (token) => {
  try {
    const response = await axiosInstance.get("/home", {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error sending Services", error);
    throw error;
  }
};

export const getPartnersByServiceID = async (id) => {
  try {
    const response = await axiosInstance.get("/get_partners_by_service_id", {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending Services", error);
    throw error;
  }
};
